/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import numsGenerator from "../utils/number-generator";
import Picker from "../theme/default/picker";

const TimePicker = ({ field, appData, components }) => {
  const hours = numsGenerator(1, 12);
  const minutes = numsGenerator(0, 59);
  const periods = ["AM", "PM"];

  const [hour, setHour] = useState(null);
  const [minute, setMinute] = useState(null);
  const [period, setPeriod] = useState(null);

  useEffect(() => {
    appData.resetItemSelected();
    appData.onItemSelected(true);
  }, []);

  useEffect(() => {
    if (hour !== null && minute !== null && period !== null) {
      appData.onItemSelected(false);
      appData.handleChange(hour, minute, period);
    }
  }, [hour, minute, period]);

  return (
    <div className={`time-picker-web-sdk ${field?.params?.split("|").join()}`}>
      <Picker
        data={hours}
        name='hour'
        value={hour}
        setValue={setHour}
        components={components}
      />
      <Picker
        data={minutes}
        name='minute'
        value={minute}
        setValue={setMinute}
        components={components}
      />
      <Picker
        data={periods}
        name='period'
        value={period}
        setValue={setPeriod}
        components={components}
      />
    </div>
  );
};

TimePicker.propTypes = {
  field: PropTypes.objectOf(PropTypes.object).isRequired,
  components: PropTypes.arrayOf(PropTypes.node).isRequired,
  appData: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.object).isRequired,
  name: PropTypes.string,
  value: PropTypes.objectOf(PropTypes.object).isRequired,
  setValue: PropTypes.func
};

export default TimePicker;
